export class CommonResponseError extends Error {
	constructor(message: string) {
		super(message);
		this.message = message;
		this.name = 'CommonResponseError';
	}
}
